import styled from 'styled-components';

const Container = styled.section`
  padding: 6rem 0 2rem;
`;

const ItemsContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-around;

  @media (max-width: 800px) {
    flex-direction: column;
  }
`;

const Line = styled.div`
  height: 1px;
  border-top: 1px solid var(--border);
  margin: 0px 10rem 0px 10rem;
  transform: translateY(-7rem);
  z-index: -1;

  @media (max-width: 800px) {
    display: none;
  }
`;

const Title = styled.h2`
  font-size: 2.6rem;
  font-weight: 700;
  text-align: center;
  margin-bottom: 4rem;

  strong {
    font-weight: 700;
    color: var(--accent);
  }
`;

export { ItemsContainer, Line, Title, Container };
